import { useCallback, useEffect, useState } from 'react';
import * as providerAdminApi from '../../../api/providerAdminApi';
import { useAuth } from '../../../auth/AuthProvider';
import { DataTable } from '../../../components/ui/DataTable';
import { canAccessProviderAdmin } from './providerAdminAccess';

export function AdminAuditPage() {
  const { session } = useAuth();
  const [items, setItems] = useState([]);
  const [error, setError] = useState(null);
  const allowed = canAccessProviderAdmin(session);

  const load = useCallback(async () => {
    setError(null);
    try {
      const data = await providerAdminApi.listAudit({ page: 1, page_size: 50 });
      setItems(data.items || []);
    } catch (err) {
      setError(err.message || 'Failed to load audit');
      setItems([]);
    }
  }, []);

  useEffect(() => {
    if (allowed) load();
  }, [allowed, load]);

  if (!allowed) {
    return <p className="text-sm text-eorig-muted">Provider Admin access is required.</p>;
  }

  return (
    <div className="space-y-4">
      <p className="text-sm text-eorig-muted">Stage 4 — admin mutations for this Provider scope.</p>
      {error ? <p className="text-sm text-red-600">{error}</p> : null}
      <DataTable
        columns={[
          { key: 'created_at', header: 'When' },
          { key: 'action', header: 'Action' },
          { key: 'target_type', header: 'Target' },
          { key: 'message', header: 'Message' },
        ]}
        rows={items}
        rowKey={(row) => row.id}
        emptyMessage="No admin audit events yet."
      />
    </div>
  );
}
